/**
 * OS DADOS DO COLABORADOR, AGRUPADOS.
 *
 * O cadastro passou a ter tudo o que a planilha do RH mantinha (documentos,
 * filiação, endereço, dados bancários…). Numa lista corrida isso vira uma
 * parede de campos; aqui eles ficam separados pelos grupos que o RH usa —
 * é o que a ficha do colaborador mostra.
 */

export interface GrupoCampos {
  titulo: string;
  campos: { campo: string; rotulo: string; tipo?: "data" | "moeda" }[];
}

export const GRUPOS_COLABORADOR: GrupoCampos[] = [
  {
    titulo: "Identificação",
    campos: [
      { campo: "nome", rotulo: "Nome" },
      { campo: "cpf", rotulo: "CPF" },
      { campo: "rg", rotulo: "RG" },
      { campo: "data_nascimento", rotulo: "Nascimento", tipo: "data" },
      { campo: "estado_civil", rotulo: "Estado civil" },
      { campo: "nome_mae", rotulo: "Nome da mãe" },
      { campo: "nome_pai", rotulo: "Nome do pai" },
    ],
  },
  {
    titulo: "Contrato e trabalho",
    campos: [
      { campo: "matricula", rotulo: "N° de registro" },
      { campo: "contrato", rotulo: "Contrato" },
      { campo: "cargo", rotulo: "Função" },
      { campo: "departamento", rotulo: "Departamento" },
      { campo: "cbo", rotulo: "CBO" },
      { campo: "salario", rotulo: "Salário", tipo: "moeda" },
      { campo: "data_admissao", rotulo: "Admissão", tipo: "data" },
      { campo: "data_demissao", rotulo: "Demissão", tipo: "data" },
      { campo: "status", rotulo: "Situação" },
    ],
  },
  {
    titulo: "Documentos de trabalho",
    campos: [
      { campo: "pis", rotulo: "PIS" },
      { campo: "ctps", rotulo: "CTPS" },
      { campo: "ctps_serie", rotulo: "Série" },
    ],
  },
  {
    titulo: "Contato",
    campos: [
      { campo: "telefone", rotulo: "Telefone" },
      { campo: "email", rotulo: "E-mail" },
      { campo: "endereco", rotulo: "Endereço" },
      { campo: "cidade", rotulo: "Cidade" },
      { campo: "cep", rotulo: "CEP" },
      { campo: "contato_emergencia", rotulo: "Contato de emergência" },
      { campo: "parente_emergencia", rotulo: "Parentesco" },
    ],
  },
  {
    titulo: "Dados bancários",
    campos: [
      { campo: "banco", rotulo: "Banco" },
      { campo: "agencia", rotulo: "Agência" },
      { campo: "conta", rotulo: "Conta" },
      { campo: "pix", rotulo: "PIX" },
    ],
  },
  {
    titulo: "Competências",
    campos: [{ campo: "skills", rotulo: "Skills" }],
  },
];

/** Formata para exibição (a ficha é só leitura). */
export function mostrar(valor: unknown, tipo?: "data" | "moeda"): string {
  if (valor == null || String(valor).trim() === "") return "—";
  const texto = String(valor);
  if (tipo === "data") {
    const d = texto.slice(0, 10);
    return /^\d{4}-\d{2}-\d{2}$/.test(d) ? d.split("-").reverse().join("/") : texto;
  }
  if (tipo === "moeda") {
    const n = Number(texto);
    return Number.isFinite(n)
      ? n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
      : texto;
  }
  return texto;
}
